import { loadRecord } from './onboardingStore';
import { supabase } from './supabaseClient';

const TOPIC_KEY = 'mns-topic-suggestions-v1';
const REPORT_KEY = 'mns-problem-reports-v1';

function remember(key: string, row: Record<string, unknown>): void {
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || '[]');
    const rows = Array.isArray(parsed) ? parsed : [];
    rows.push({ ...row, savedAt: new Date().toISOString() });
    localStorage.setItem(key, JSON.stringify(rows.slice(-40)));
  } catch {
    // The screen still says the note stayed on this device.
  }
}

export async function saveTopicSuggestion(input: {
  userId: string | null;
  topic: string;
}): Promise<'saved' | 'device' | 'invalid'> {
  const topic = input.topic.trim();
  if (topic.length < 2 || topic.length > 200) return 'invalid';
  const guestKey = loadRecord()?.guestKey ?? null;
  const { error } = await supabase.from('topic_suggestions').insert({
    user_id: input.userId,
    guest_key: guestKey,
    topic,
  });
  if (!error) return 'saved';
  remember(TOPIC_KEY, { topic, userId: input.userId, guestKey });
  return 'device';
}

export async function saveProblemReport(input: {
  userId: string | null;
  kind: 'account_billing' | 'other';
  details: string;
}): Promise<'saved' | 'device' | 'invalid'> {
  const details = input.details.trim();
  if (details.length < 1 || details.length > 800) return 'invalid';
  const guestKey = loadRecord()?.guestKey ?? null;
  const { error } = await supabase.from('problem_reports').insert({
    user_id: input.userId,
    guest_key: guestKey,
    kind: input.kind,
    details,
  });
  if (!error) return 'saved';
  remember(REPORT_KEY, { kind: input.kind, details, userId: input.userId, guestKey });
  return 'device';
}
